<template>
  <el-dialog
    class="share-dialog"
    title="Send Email"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :show-close="false"
    append-to-body
    width="480px"
  >
    <div>
      <el-form
        :model="dynamicValidateForm"
        ref="dynamicValidateForm"
        label-width="70px"
        class="demo-dynamic"
      >
        <el-form-item
          v-for="(email, index) in dynamicValidateForm.emails"
          :label="$t('text.email') + (index + 1)"
          :key="email.key"
          :prop="'emails.' + index + '.value'"
          :rules="[
            {
              required: true,
              message: 'Please enter email address',
              trigger: 'blur'
            },
            {
              type: 'email',
              message: 'Please enter the correct email address',
              trigger: ['blur', 'change']
            }
          ]"
        >
          <el-input v-model="email.value"></el-input>
          <div class="inline-block">
            <div
              class="delete-item operate-item-btn"
              @click.prevent="removeEmail(email)"
            >
              <img src="../../../assets/delete.svg" class="w-20" />
            </div>
          </div>
        </el-form-item>
        <el-form-item class="btn-wrapper">
          <el-button
            type="primary"
            :loading="loading"
            :disabled="loading"
            @click="submitForm('dynamicValidateForm')"
            >Send</el-button
          >
          <el-button @click="closeDialog()">{{ $t('text.cancel') }}</el-button>
          <el-button
            icon="el-icon-plus"
            @click="addEmail"
            class="right-float mt-3"
            >Add Email</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import ApiService from '@/services/ReportApiService.js'
import swal from 'sweetalert'
export default {
  data() {
    return {
      dialogVisible: false,
      dynamicValidateForm: {
        emails: [
          {
            value: ''
          }
        ]
      },
      loading: false
    }
  },
  methods: {
    openDialog() {
      this.dialogVisible = true
      this.dynamicValidateForm = {
        emails: [
          {
            value: ''
          }
        ]
      }
    },
    closeDialog() {
      this.resetForm()
      this.dialogVisible = false
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.handleSendEmail(this.$parent.$parent.$refs.form.$el.innerHTML)
        }
      })
    },
    handleSendEmail(domContent) {
      let recipients = this.dynamicValidateForm.emails.map(item => {
        return item.value
      })
      this.loading = true
      ApiService.SendEmail({
        recipients: recipients,
        subject: this.$parent.$parent.printInfo.popTitle,
        emailContent: this.getEmailContent(),
        fileContent: this.setStyle(domContent)
      })
        .then(response => {
          this.loading = false
          if (response.data.success) {
            swal({
              icon: 'success',
              timer: 2000,
              title: 'Sent Successfully'
            })
            this.closeDialog()
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: 'Sent Failed',
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: 'Sent Failed'
          })
        })
    },
    getEmailContent() {
      return `
        <!DOCTYPE html>
        <html >
        <head>
            <meta charset="utf-8">
            <meta name="viewport" content="width=device-width,initial-scale=1">
            <style>  
            </style>
        </head>
        <body>
          <div>Hi everyone,</div>
          <div style="margin-left: 20px">Attached is the ${this.$parent.$parent.printInfo.popTitle}, please check.</div>
          <br />
          <div>Best Regards,</div>
          <div>Simavita</div>
        </body>
        </html>
      `
    },
    setStyle(html) {
      return `
        <!DOCTYPE html>
        <html >
        <head>
            <meta charset="utf-8">
            <meta name="viewport" content="width=device-width,initial-scale=1">
            <style>  
            body {
              font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
            }
            .title {
              display: block !important;
            }
            .total-time-line {
              text-align: right;
              padding-right: 20px;
              font-size: 14px;
              font-weight: bold;
              margin-bottom: 15px;
            }
            .pre-input {
              display: block;
              padding: 5px 15px;
              line-height: 1.5;
              font-size: 10px;
              color: #606266;
              border: 1px solid #DCDFE6;
              border-radius: 4px;
              font-family: inherit;
              margin-bottom: 0;
              min-height: 16px;
              width: 97%;
            }
            .desc-wrapper {
              background: rgba(128, 211, 246, 0.3);
              padding-top: 5px;
              padding-bottom: 5px;
              margin-bottom: 15px;
              position: relative;
              border-radius: 3px;
              margin-top: 10px;
            }
            .desc-wrapper::before {
                  content: '';
                  position: absolute;
                  left: 0;
                  top: 0;
                  width: 3px;
                  height: 100%;
                  background-color: #409EFF;
                  border-top-left-radius: 3px;
                  border-bottom-left-radius: 3px;
              }
            .desc-wrapper .desc-info {
                  color: #409EFF;
                  font-weight: bold;
                  margin-left: 20px;
              }
            .desc-wrapper .second-desc {
                  position: absolute;
                  left: 50%;
                  top: 5px;
              }
            .desc-wrapper .helper-info {
                  font-size: 12px;
                  margin-right: 20px;
                  float: right;
              }
            .pass-input {
                background: #CAF982;
                border-color: #CAF982;
            }
            .failed-input {
                background: #EC808D;
                border-color: #EC808D;
            }
            .el-form-item {
                margin-bottom: 5px !important;
            }
            .el-form-item__label {
              text-align: right;
              vertical-align: middle;
              float: left;
              font-size: 12px;
              color: #606266;
              line-height: 40px;
              padding: 0 12px 0 0;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              line-height: 28px
            }
            .el-form-item__content {
              line-height: 28px;
              position: relative;
              font-size: 14px;
            }
            </style>
        </head>
        <body>
          ${html} 
        </body>
        </html>
  `
    },
    resetForm() {
      this.$refs['dynamicValidateForm'].resetFields()
    },
    removeEmail(item) {
      if (this.dynamicValidateForm.emails.length === 1) {
        this.$message({
          message: 'Please enter at least one email address',
          type: 'warning'
        })
        return false
      }
      var index = this.dynamicValidateForm.emails.indexOf(item)
      if (index !== -1) {
        this.dynamicValidateForm.emails.splice(index, 1)
      }
    },
    addEmail() {
      this.dynamicValidateForm.emails.push({
        value: '',
        key: Date.now()
      })
    }
  }
}
</script>
